const forms = [...document.querySelectorAll('.productcard-quick-add-to-cart')]

forms.forEach((form) => {
  const idleIcon = form.querySelector('.quick-add-to-cart-icon-idle')
  const submittedIcon = form.querySelector('.quick-add-to-cart-icon-submitted')
  const loadingIcon = form.querySelector('.quick-add-to-cart-icon-loading')

  let submitting = false

  form.addEventListener('submit', async (event) => {
    event.preventDefault()

    if (submitting) {
      return
    }

    const productId = form.elements.productId?.value

    submitting = true
    idleIcon.style.setProperty('display', 'none')
    submittedIcon.style.setProperty('display', 'none')
    loadingIcon.style.removeProperty('display')

    try {
      const response = await window.fetch(`/api/quick-add-to-cart/${productId}`, {
        method: 'POST',
        credentials: 'same-origin',
      })

      if (!response.ok) {
        throw new Error()
      }

      const { data } = await response.json()

      const cartItemsIndicator = document.getElementById('cartItms')
      if (cartItemsIndicator !== null) {
        cartItemsIndicator.innerHTML = data.cartItems
      }

      idleIcon.style.setProperty('display', 'none')
      submittedIcon.style.removeProperty('display')
      loadingIcon.style.setProperty('display', 'none')
    } catch {
      idleIcon.style.removeProperty('display')
      submittedIcon.style.setProperty('display', 'none')
      loadingIcon.style.setProperty('display', 'none')
    } finally {
      submitting = false
    }
  })
})
